<template>
  <div
    v-if="banner.display && banner.message"
    class="relative pin-t w-screen pt-5 px-6 pb-6 bg-white banner z-50"
  >
    <div class="md:flex max-w-2xl md:max-w-2xl md:mx-auto md:items-center md:justify-between">
      <BaseParagraph class="mb-3">
        {{ $t(banner.message) }}
      </BaseParagraph>
      <div class="md:flex">
        <BaseButton
          :to="banner.button.to"
          :title="$t(banner.button.title)"
          class="md:mr-8 whitespace-no-wrap"
        />
        <div
          class="flex items-center justify-center cursor-pointer"
          @click="resetBanner()"
        >
          <Cross class="md:hidden absolute h-3 w-3 cross-position" />
          <Cross class="hidden md:block h-3 w-3" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import BaseButton from './BaseButton.vue';
import BaseParagraph from './BaseParagraph.vue';
import Cross from './icons/Cross.vue';

export default {
  name: 'TheBanner',
  components: {
    BaseButton,
    BaseParagraph,
    Cross,
  },
  computed: mapState(['banner']),
  methods: mapActions(['resetBanner']),
};
</script>

<style lang="scss">
  .banner {
    box-shadow: 0px 10px 10px -9px rgba(212,212,212,1);
  }

  .cross-position {
    right: 24px;
    top: 24px;
  }
</style>
